import React from 'react'

import { usePopover } from './usePopover'

type ContextType =
  | (ReturnType<typeof usePopover> & {
      setLabelId: React.Dispatch<React.SetStateAction<string | undefined>>
      setDescriptionId: React.Dispatch<React.SetStateAction<string | undefined>>
    })
  | null

export const PopoverContext = React.createContext<ContextType>(null)
